import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('calc_cart_item')
export default class CalcCartItem {
  constructor() {
    this.cartItemId = 0;
    this.totalAmount = 0;
    this.serialCodes = [];
  }

  @JsonProperty('cart_item_id')
  public cartItemId: number;

  @JsonProperty('total_amount')
  public totalAmount: number;

  @JsonProperty('serial_codes', [String], true)
  public serialCodes: string[];
}
